<template>
	<!-- //点击上传 -->
	<div class="labelUpload">
		<span :style="{color:spanColor,fontSize:spanFontSize+'px',width:spanWidth,}" class="innerSpan">
			<span style="color: red;" v-if="spanRequired">*&nbsp;</span>
			{{spanTitle}}:</span>
		<div class="innerP">
			<!-- 点击上传 -->
			<img src="../../assets/img/main/附件.png" style="display: inline-block;width: 17px;height: 17px;margin-right: 10px;" v-if="imgShow">
			<el-upload class="upload-demo" :action="actionUrl" :on-preview="handlePreview" :on-remove="handleRemove"
				:before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed" :file-list="fileList">
				<p style="font-size: 14px;color: #409EFF;text-decoration: underline;">点击上传</p>
				<div slot="tip" class="el-upload__tip" v-if="tipText">
					{{tipText}}
				</div>
			</el-upload>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fileList: []
			}
		},
		props: {
			// span类
			spanColor: {
				type: String,
				default: '#000'
			},
			spanFontSize: {
				type: Number,
				default: 16
			},
			spanTitle: {
				type: String,
				default: '标题'
			},
			spanWidth: {
				type: String,
				default: '100px'
			},
			spanRequired: {
				type: Boolean,
				default: false
			},
			tipText: {
				type: String,
				default: ''
			},
			actionUrl: {
				type: String,
				default: ''
			},
			imgShow:{
				type:Boolean,
				default:false
			}
		},
		methods: {
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			}
		}
	}
</script>

<style scoped>
	.labelUpload {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		width: auto;
		min-height: 100px;
		height: auto;
		line-height: 40px;
	}

	.innerSpan {
		display: inline-block;
	/*	display: inherit;*/
		justify-content: flex-end;
		text-align: left;
	}

	.innerP {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		/* padding-left: 20px; */
	}
</style>
